import styled from "styled-components";

export const MainWrapper = styled.main`
  background-color: whitesmoke;
  width: 100%;
  min-height: 1000px;
`;
